var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CollapsibleForm_1;
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { observable } from '@slickdeals/durango/dist/javascript/decorators/observable';
import TargetStrategy from '@slickdeals/durango/dist/javascript/strategies/visibility/targetStrategy';
import TriggerStrategy from '@slickdeals/durango/dist/javascript/strategies/visibility/triggerStrategy';
import BlueprintComponent from '../core/blueprintComponent';
import VisibilityToggle, { ObservableEvents as VisibilityToggleObserverableEvents, ClassNames as VisibilityToggleClassNames } from './visibilityToggle';
import './button';
import '../../scss/components/collapsibleForm.scss';
/** The name of the module */
export const name = 'CollapsibleForm';
/** Classnames for this module */
export const ClassNames = {
    Default: 'bp-c-collapsibleForm',
    JavaScript: 'js-collapsibleForm',
};
let CollapsibleForm = CollapsibleForm_1 = class CollapsibleForm extends BlueprintComponent {
    constructor(options) {
        super(name, options);
        // Sets the additional triggers (if applicable)
        this.additionalTriggers = options.additionalTriggers;
    }
    /**
      * Create a new instance of this object
      *
      * @param options Data and options to initialize component with
      */
    static create(options) {
        return new CollapsibleForm_1(options);
    }
    async init() {
        super.init();
        this.element = await BlueprintComponent.loadElement(name, this.options);
        // Creates the visibilityToggle instance
        this.initVisibilityToggle();
    }
    /**
     * Initialized the visibility toggle instance for this module
     * Creates all dependencies manually
     */
    initVisibilityToggle() {
        const trigger = this.element.querySelector('.bp-c-collapsibleForm_button');
        const target = this.element.querySelector('.bp-c-collapsibleForm_target');
        const triggerStrategyOptions = {
            element: trigger,
            classNames: {
                base: VisibilityToggleClassNames.Default,
                visible: VisibilityToggleClassNames.Visible,
            },
            enableVisibilityToggling: true,
            additionalTriggers: this.additionalTriggers,
        };
        this.visibilityToggle = new VisibilityToggle({
            triggerStrategy: new TriggerStrategy(triggerStrategyOptions),
            targetStrategy: new TargetStrategy({
                classNames: {
                    base: VisibilityToggleClassNames.Default,
                    visible: VisibilityToggleClassNames.Visible,
                },
                elements: target,
            }),
        });
        this.visibilityToggle.subscribe((visibilityData) => {
            this.notify(visibilityData);
        }, VisibilityToggleObserverableEvents.Toggled);
    }
};
CollapsibleForm = CollapsibleForm_1 = __decorate([
    observable,
    injectable(name)
], CollapsibleForm);
export default CollapsibleForm;
/** Add ReportButton component in the hydration queue */
BlueprintComponent.instantiate(name);
